import moment from "moment-timezone";
import { Apollo, State2Way } from "@/decorators";
import { isInsideClosedAccountingPeriod } from "../services/accountingPeriods";

import DELETE_RECONCILIATION from "../graphql/reconciliation/DeleteReconciliation.gql";
import LINK_BANKTRANSACTION_AND_DOCUMENT from "../graphql/bankTransaction/LinkBankTransactionAndDocument.gql";
import REMOVE_LINKED_ACCOUNTING_LINES from "../graphql/bankTransaction/RemoveLinkedAccountingLines.gql";
import UPDATE_BANKTRANSACTION_ACCOUNTINGLINE from "../graphql/bankTransaction/UpdateBankTransactionAccountingLines.gql";
import CREATE_RECONCILIATION_FROM_CLIENT from "../graphql/reconciliation/CreateReconciliationFromClient.gql";
import RECONCILIATION_ACCOUNTING_LINE_QUERY from "../graphql/reconciliation/ReconciliationAccountingLines.gql";
import RECONCILIATION_BT_QUERY from "../graphql/reconciliation/ReconciliationBankTransactions.gql";
import RECONCILIATION_WITH_SEARCH_QUERY from "../graphql/reconciliation/reconciliationsFromBTsAndDocuments.gql";
import REMOVE_TO_CASHBOX from "../graphql/reconciliation/RemoveToCashBox.gql";
import VALIDATE_RECONCILIATION from "../graphql/reconciliation/ValidateReconciliation.gql";

import {
    socialAccountableAccounts,
    stateAccountableAccounts,
} from "../services/accountableAccountServices";
import { DialogAction } from "../services/dialogAction";
import { formatOrderBy, getCommonBTQueryVariables } from "../services/graphqlServices";
import { getStringAsFloat } from "../services/mathServices";
import {
    linkBankTransactionWithCashBox,
    reconciliateAlWithBT,
} from "../services/reconciliationServices";
import { UserActivity } from "../services/userActivityServices";

// import AccountableAccountVue from "./AccountableAccount.vue";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { Component, Watch } from "vue-facing-decorator";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";
import { ReconciliationBase } from "./ReconciliationBase";

const suspensePurchaseAccount = "600000";
const suspenseSalesAccount = "700000";

@Component({
    emits: ["update", "new-document"],
})
export class ReconciliationFullBase extends ReconciliationBase {
    previousReconciliationId: string = "";

    selectedGroup = null;

    documentExpanded = [];

    reconciliationPagination: any = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
    };

    reconciliation1NPagination: any = {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
    };

    removedInitialItems = [];
    reconciliationExpanded = [];

    currentItem = null;
    //
    get groupItemsHeaders() {
        const headers = [
            { text: "Type", value: "type", sortable: false, align: "center" },
            { text: "Libellé", value: "name", sortable: false, align: "center" },
        ];
        if (this.isAccountingUser) {
            headers.push({ text: "Action", value: "", sortable: false, align: "center" });
        }
        headers.push(
            ...[
                { text: "Date", value: "date", sortable: false, align: "center" },
                { text: "Débit", value: "debit", sortable: false, align: "right" },
                { text: "Crédit", value: "credit", sortable: false, align: "right" },
            ],
        );
        return headers;
    }

    get groupItemsHeaders2() {
        const headers = [
            { title: "Type", value: "type", sortable: false, align: "center" },
            { title: "Libellé", value: "name", sortable: false, align: "center" },
        ];
        headers.push(
            ...[
                { title: "Date", value: "date", sortable: false, align: "center" },
                { title: "Débit", value: "debit", sortable: false, align: "right" },
                { title: "Crédit", value: "credit", sortable: false, align: "right" },
            ],
        );
        if (this.isAccountingUser) {
            headers.push({
                title: "Compte",
                value: "accountableAccount",
                sortable: false,
                align: "center",
            });
        }
        headers.push({ title: "Statut", value: "status", sortable: false, align: "center" });
        if (this.isAccountingUser) {
            headers.push({ title: "Action", value: "", sortable: false, align: "center" });
        }
        return headers;
    }

    suggestedDocumentHeaders = [
        { title: "Nom", value: "name", sortable: true },
        { title: "Date", value: "date", sortable: true },
        { title: "Débit", value: "debit", sortable: false },
        { title: "Crédit", value: "credit", sortable: false },
        { title: "Action", value: "action", sortable: false },
    ];
    //
    // BT selection
    //

    bankTransactionPanel = false;

    // availableBankTransactions = [];
    // selectedBankTransactions: any[] = [];

    showBTRangePicker = false;

    loadingBT: boolean = false;

    defaultBTFilter = {
        search: "",
        showFilterBox: false,
        amount: {
            maximum: "",
            minimum: "",
        },
        date: {
            begin: "",
            end: "",
            format: "YYYY-MM-DD",
        },
        pagination: {
            sortBy: [{ key: "dateDebit", order: false }],
            descending: false,
            page: 1,
            rowsPerPage: 5,
            totalItems: 0,
        },
    };

    btFilter = {
        search: "",
        showFilterBox: false,
        amount: {
            maximum: "",
            minimum: "",
        },
        date: {
            begin: "",
            end: "",
            format: "YYYY-MM-DD",
        },
        pagination: {
            sortBy: [{ key: "dateDebit", order: false }],
            descending: false,
            page: 1,
            rowsPerPage: 5,
            totalItems: 0,
        },
    };

    documentDialog = false;
    selectedDocument = null;

    actionLoading: boolean = false;

    showActionMenu: boolean = false;
    xMenuAction = 0;
    yMenuAction = 0;

    @Watch("btFilter.search")
    @Watch("btFilter.amount.minimum")
    @Watch("btFilter.amount.maximum")
    @Watch("btFilter.date.begin")
    @Watch("btFilter.date.end")
    onBTFilterChanged() {
        this.btFilter.pagination.page = 1;
        this.availableBankTransactions = [];
    }

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod.selectedAccountingClosing?.id
            ? this.$store.state.accountingPeriod.selectedAccountingClosing
            : null;
    }

    activateActionMenu(e, group) {
        debugger;
        e.preventDefault();
        this.showActionMenu = false;
        this.selectedGroup = null;
        this.xMenuAction = e.clientX;
        this.yMenuAction = e.clientY;
        this.$nextTick(() => {
            this.showActionMenu = true;
            this.selectedGroup = group;
        });
    }

    //
    // Documents suggested
    //
    suggestedDocumentPanel = false;

    suggestedDocumentExpanded = [];

    addRemoveSuggestedDocumentExpand(item) {
        const index = this.suggestedDocumentExpanded.indexOf(item);
        if (index === -1) {
            this.suggestedDocumentExpanded.push(item);
        } else {
            this.suggestedDocumentExpanded.splice(index, 1);
        }
    }

    // isSuggestedDocExpended(item) {
    //     return this.suggestedDocumentExpanded.indexOf(item) !== -1;
    // }

    get suggestedDocuments() {
        if (this.reconciliation && this.reconciliation.toReplaceAccountingLineSuggestionItems)
            return this.reconciliation.toReplaceAccountingLineSuggestionItems;
        return [];
    }

    replaceBySuggestedDocument(item) {
        const previousDocIndex = this.reconciliationItems.findIndex(
            (ri) => !!ri.doc && ri.doc.type === this.reconciliation.toReplaceDocumentType,
        );
        if (previousDocIndex !== -1) {
            const previousDocItem = this.reconciliationItems[previousDocIndex];
            if (previousDocItem.id !== item.id) {
                if (previousDocItem.doc.type === this.reconciliation.toReplaceDocumentType) {
                    this.reconciliationItems.splice(previousDocIndex, 1, item);
                    this.removedInitialItems.push(previousDocItem);
                    // selected
                    previousDocItem.selected = false;
                } else {
                    const index = this.reconciliation.toReplaceAccountingLineSuggestionItems(
                        (ri) => ri.id === previousDocItem.id,
                    );
                    if (index !== -1) {
                        this.reconciliationItems.splice(previousDocIndex, 1, item);
                    }
                }
            }
            //
            // accountableAccount
            //
            if (!item.accountableAccountAuto && !!previousDocItem.accountableAccountAuto) {
                item.accountableAccountAuto = previousDocItem.accountableAccountAuto;
            }
            if (!item.accountableAccount && !!previousDocItem.accountableAccount) {
                item.accountableAccount = previousDocItem.accountableAccount;
            }
            if (
                !item.accountableAccountSuggestions.length &&
                previousDocItem.accountableAccountSuggestions.length
            ) {
                item.accountableAccountSuggestions = previousDocItem.accountableAccountSuggestions;
            }
        }
    }

    //
    // Document selection
    //

    showDocRangePicker = false;

    loadingDocument: boolean = false;

    // document selection
    documentPanel = false;
    // documents = [];
    // selectedDocuments: any[] = [];

    defaultDocFilter = {
        search: "",
        showFilterBox: false,
        amount: {
            maximum: "",
            minimum: "",
        },
        date: {
            begin: "",
            end: "",
            format: "YYYY-MM-DD",
        },
        pagination: {
            sortBy: "wording",
            descending: false,
            page: 1,
            rowsPerPage: 5,
            totalItems: 0,
        },
    };

    docFilter: any = {
        search: "",
        showFilterBox: false,
        amount: {
            maximum: "",
            minimum: "",
        },
        date: {
            begin: "",
            end: "",
            format: "YYYY-MM-DD",
        },
        pagination: {
            sortBy: "wording",
            descending: false,
            page: 1,
            rowsPerPage: 5,
            totalItems: 0,
        },
    };

    defaultReconciliationFilter = {
        search: "",
        showFilterBox: false,
        amount: {
            maximum: "",
            minimum: "",
        },
        date: {
            begin: "",
            end: "",
            format: "YYYY-MM-DD",
        },
        // pagination: {
        //     page: 1,
        //     rowsPerPage: 5,
        //     rowsPerPages: [5, 10, 25],
        //     totalItems: 0
        // }
    };

    reconciliationFilter: any = {
        search: "",
        showFilterBox: false,
        amount: {
            maximum: "",
            minimum: "",
        },
        date: {
            begin: "",
            end: "",
            format: "YYYY-MM-DD",
        },
        // pagination: {
        //     sortBy: 'wording',
        //     descending: false,
        //     page: 1,
        //     rowsPerPage: 5,
        //     totalItems: 0
        // }
    };

    get reconciliationVue() {
        return this;
    }

    //
    // reconciliations
    //
    reconciliationPanel: boolean = false;
    reconciliationLoading: boolean = false;

    closeAllPanels() {
        this.documentPanel = false;
        this.suggestedDocumentPanel = false;
        this.bankTransactionPanel = false;
        this.reconciliationPanel = false;
        // this.reconciliation1NPanel = false
    }

    get activateReconciliationPanel() {
        return true;
    }

    // skipQuery = true;

    // fec
    fec: any[] = [];

    fecHeaders: any[] = [];

    showFEC = false;

    toCreateBankTransactions;

    get declareSalesInvoices() {
        if (this.selectedCompany.incomeCategory === "BNC" && isNotSubjectToVAT(this.selectedCompany))
            return false;
        return true;
    }

    get legalForm() {
        return this.selectedCompany.legalForm;
    }

    get advice() {
        return "valider le document";
    }

    isMainItem(group, item) {
        if (!group.mainItem) {
            return true;
        }
        return group.mainItem.id === item.id;
    }

    // ---------------
    // auto sale : BNC
    // ---------------

    autoSalesReconciliation: boolean = false;

    autoSalesActions: any = {
        action: new DialogAction(),
    };

    showAutoSalesReconciliation(group) {
        if (this.declareSalesInvoices) return undefined;
        // let counter = 0;
        if (group) {
            if (group.items.length !== 1) {
                return undefined;
            }
            const item = group.items[0];
            if (!item || !item.accountingLine.accountableAccount?.name.startsWith("471000")) {
                return undefined;
            }
            return item;
        }
    }

    // ------------------
    // ThirdParty Company
    // ------------------

    showThirdPartyCompanyDialog = false;

    get thirdPartyCompanyBTItem() {
        if (this.currentAccountType) {
            return false;
        }
        let btItem;
        for (const item of this.reconciliationItems) {
            if (item.doc) return false;
            if (item.bt && item.is471AL) {
                if (btItem) return false;
                btItem = item;
            }
        }
        return btItem;
    }

    getThirdPartyCompanyBTItem(group) {
        if (this.isIncomingOutgoingPayment) {
            return undefined;
        }
        if (!group) {
            return undefined;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        if (this.getCurrentAccountType(group)) {
            return undefined;
        }
        const item = group.items[0];
        return item.bt && item.is471AL ? item : undefined;
    }

    async onThirdPartyCompanyChanged() {
        this.showThirdPartyCompanyDialog = false;
        await this.refresh();
    }

    // ---------------
    // WITHOUT INVOICE
    // ---------------

    getWithoutInvoiceBT(group) {
        if (this.isIncomingOutgoingPayment) {
            return false;
        }
        let btItem;
        if (!group) {
            return btItem;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        if (this.getCurrentAccountType(group)) {
            return false;
        }
        const item = group.items[0];
        return item.bt && item.is471AL ? item : undefined;
    }

    showWithoutInvoiceDialog: boolean = false;
    withoutInvoiceActions: any = {
        action: new DialogAction(),
    };

    // ----------
    // WITH DELTA
    // ----------

    validationWithDelta: boolean = false;

    showWithDelta() {
        if (this.reconciliationItems.length < 2) {
            return false;
        }
        const absDiff = Math.abs(this.totalCredit - this.totalDebit);
        if (absDiff > 1e-2 && absDiff < 50) {
            return true;
        }
        return false;
    }

    getWithDeltaBT(group) {
        if (!group) return undefined;
        if (group.items.length !== 1) return undefined;
        const item = group.items[0];
        if (
            !item.bt ||
            !item.is471AL ||
            !item.bt.account ||
            item.bt.account.type === "CASH_BOX" ||
            item.accountingLine.id
        ) {
            return false;
        }
        if (
            !item.accountingLine.accountableAccount ||
            item.accountingLine.accountableAccount.name !== this.waitingAA.name
        ) {
            return false;
        }
        // const absDiff = Math.abs(this.totalCredit - this.totalDebit);
        const amount = Math.abs(item.accountingLine.amountSigned);
        if (amount > 1e-2 && amount <= 2.0) {
            return item;
        }
        return undefined;
    }

    // ----------
    // commission
    // ----------

    showAddCommissionDialog = false;
    commissionActions = {
        action: new DialogAction(),
    };

    get showCommission() {
        if (this.currentAccountType) {
            return false;
        }
        if (this.waitingForValidation) {
            return false;
        }
        const dicoDates = [];
        const btWithCommisions = {};
        for (const item of this.reconciliationItems) {
            if (
                item.bt &&
                item.is471AL &&
                !btWithCommisions[item.bt.id] &&
                item.bt.account.type === "BANK" &&
                item.bt.amount > 0
            ) {
                btWithCommisions[item.bt.id] = true;
                const date = dicoDates.find((d) => d.dateKey === item.date);
                if (date) {
                    date.count++;
                } else {
                    dicoDates.push({
                        dateKey: item.date,
                        date: item.bt.dateDebit,
                        count: 1,
                    });
                }
            }
        }
        for (const item of this.reconciliationItems) {
            if (item.doc) {
                if (item.doc.zTillReceipt) {
                    return false;
                }
                if (item.doc.type === "BANK_CHARGE") {
                    const date = dicoDates.find((d) => d.dateKey === item.date);
                    if (date) {
                        date.count--;
                    }
                }
            }
        }
        // const dates = [];
        for (const date of dicoDates) {
            // if (date.count > 0) dates.push(date);
            if (date.count > 0) return true;
        }
        return false;
        // return dates;
    }

    getCommissionBTItem(group) {
        if (!group) {
            return undefined;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        if (!group.items[0].bt) {
            return undefined;
        }
        if (!group.items[0].is471AL) {
            return undefined;
        }
        if (this.getCurrentAccountType(group)) {
            return undefined;
        }

        if (this.isThirdPartyGroup(group)) {
            return undefined;
        }
        if (this.waitingForValidation) {
            return undefined;
        }
        return group.items[0];
    }

    //
    // Loan
    //

    showAddLoanDialog = false;
    loanActions = {
        action: new DialogAction(),
    };

    getLoanBT(group) {
        if (!group) {
            return undefined;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        if (this.getCurrentAccountType(group)) {
            return undefined;
        }

        if (this.isThirdPartyGroup(group)) {
            return undefined;
        }
        const item = group.items[0];
        return item.bt && item.is471AL ? item : undefined;
    }

    //
    // Edit
    //
    showAccountingItemDialog = false;

    //
    // CutAccountingLine
    //

    showCutAccountingLineDialog = false;
    cutAccountingLineActions = {
        action: new DialogAction(),
    };

    //
    // ztill
    //

    zTillActions = {
        action: new DialogAction(),
    };

    get zTillReceiptAllowed() {
        if (this.selectedCompany && this.selectedCompany.profile) {
            return this.selectedCompany.profile.createZTillReceipt;
        }
        return true;
    }

    showZTillDialog = false;

    get zTillBT() {
        if (!this.zTillReceiptAllowed) {
            return undefined;
        }
        let btItem;
        if (this.currentAccountType) {
            return btItem;
        }

        for (const item of this.reconciliationItems) {
            if (item.doc && item.doc.type !== "BANK_CHARGE" && item.doc.type !== "VAT")
                return false;
            if (item.bt && item.is471AL) {
                if (item.accountingLine.amountSigned > 0) {
                    if (!item.accountingLine || !item.accountingLine.reconciliation) {
                        return false;
                    }
                    continue;
                } else if (item.accountingLine.amountSigned < 0) {
                    if (item.accountingLine && !item.accountingLine.reconciliation) {
                        if (btItem) return false;
                        btItem = item;
                    } else {
                        return false;
                    }
                }
            }
        }
        return btItem;
    }

    getZTillBT(group) {
        if (!this.zTillReceiptAllowed) {
            return false;
        }
        if (!group) {
            return undefined;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        if (this.getCurrentAccountType(group)) {
            return undefined;
        }

        if (this.isThirdPartyGroup(group)) {
            return undefined;
        }

        for (const item of group.items) {
            // if (item.doc && (item.doc.type !== "BANK_CHARGE" && item.doc.type !== "VAT")) return false;
            if (item.bt && item.is471AL) {
                if (item.accountingLine.amountSigned < 0) {
                    if (item.accountingLine && !item.accountingLine.reconciliation) {
                        return item;
                    } else {
                        return undefined;
                    }
                }
            }
        }
        return undefined;
    }

    //
    //
    //
    removeCashBoxDialog = false;

    //
    // waiting bt item
    //

    get waitingBTItem(): any {
        let btItem: any;
        if (this.currentAccountType) {
            return btItem;
        }
        // if (this.reconciliationItems.length !== 1) {
        //     return false
        // }
        for (const item of this.reconciliationItems) {
            if (
                item.bt &&
                item.is471AL &&
                item.accountingLine &&
                !item.accountingLine.reconciliation
            ) {
                btItem = item;
            }
        }
        return btItem;
    }

    //
    // cut
    //

    async cutBTAccountingLine(btItem, amount1, amount2) {
        if (btItem && btItem.bt) {
            const bankTransaction = btItem.bt;
            const accountingLine = btItem.accountingLine;
            const variables = {
                // id: this.reconciliation ? this.reconciliation.id : bankTransaction.id,
                id: bankTransaction.id,
                // notJustifiedAmountSigned: 0,
                // justifiedAmountSigned: 0,
                accountingLines: [],
                toDeleteAccountingLineIds: [],
            };
            // let notJustifiedAmountSigned = bankTransaction.notJustifiedAmountSigned
            // if (!accountingLine.id) {
            //     notJustifiedAmountSigned += accountingLine.amountSigned
            // }
            // computeJustifiedNotJustified(bankTransaction.amount, notJustifiedAmountSigned, variables)

            if (accountingLine.id) {
                variables.toDeleteAccountingLineIds = [accountingLine.id]; //[{ id: accountingLine.id }]
            }

            // if (bankTransaction.accountableAccount) {
            //     variables.accountableAccount = { disconnect: true }
            // }

            const al1: any = {
                // company: {connect: {id: this.selectedCompany.id}},
                wording: accountingLine.wording,
                // date: accountingLine.date,
                amountSigned: amount1,
                accountableAccount: accountingLine.accountableAccount,
                thirdPartyCompanyId: accountingLine.thirdPartyCompany
                    ? accountingLine.thirdPartyCompany?.id
                    : undefined,
                userId: accountingLine.user?.id ? accountingLine.user.id : undefined,
                // amount: Math.abs(amount1)
            };
            // if (accountingLine.user) {
            //     al1.user = { connect: { id: accountingLine.user.id } }
            // }
            // if (accountingLine.accountableAccount) {
            //     al1.accountableAccount = await getConnectAccountableAccount(this.$store, this.$apollo, accountingLine.accountableAccount.name)
            // }
            // if (accountingLine.thirdPartyCompany) {
            //     al1.thirdPartyCompany = { connect: { id: accountingLine.thirdPartyCompany.id } }
            // }

            const al2 = JSON.parse(JSON.stringify(al1));
            al2.amountSigned = amount2;
            // al2.amount = Math.abs(amount2)

            // computeDebitCredit(al1)
            // computeDebitCredit(al2)

            variables.accountingLines = [al1, al2];

            await this.$apollo.mutate({
                mutation: UPDATE_BANKTRANSACTION_ACCOUNTINGLINE,
                variables: variables,
            });
            await this.refresh();
        } else {
            debugger;
        }
    }

    //
    // currentAccount
    //

    showLinkWithCurrentAccountDialog: boolean = false;
    currentAccountActions = {
        action: new DialogAction(),
    };

    get currentAccountBTItem(): any {
        let btItem: any;
        if (this.currentAccountType) {
            return btItem;
        }
        if (this.reconciliationItems.length !== 1) {
            return false;
        }
        const item = this.reconciliationItems[0];
        if (item.bt && item.bt.is471AL) {
            btItem = item;
        }
        return btItem;
    }

    getCurrentAccountBTItem(group): any {
        if (!group) {
            return undefined;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        if (this.getCurrentAccountType(group)) {
            return undefined;
        }

        if (this.isThirdPartyGroup(group)) {
            return undefined;
        }
        const item = group.items[0];

        return item.bt && item.is471AL ? item : undefined;
    }

    async addCurrentAccount(currentAccountUser, accountableAccountName, btItem: any = null) {
        const currentAccountBTItem = btItem || this.getCurrentAccountBTItem(this.selectedGroup);
        if (currentAccountBTItem && currentAccountBTItem.bt && accountableAccountName) {
            const bankTransaction = currentAccountBTItem.bt;

            let notJustifiedAmountSigned = bankTransaction.notJustifiedAmountSigned;
            if (!currentAccountBTItem.accountingLine.id) {
                notJustifiedAmountSigned += currentAccountBTItem.accountingLine.amountSigned;
            }
            const variables: any = {
                // id: this.reconciliation ? this.reconciliation.id : bankTransaction.id,
                id: bankTransaction.id,
                // notJustifiedAmountSigned: 0,
                // justifiedAmountSigned: 0,
                accountingLines: [],
                toDeleteAccountingLineIds: [],
            };
            // computeJustifiedNotJustified(bankTransaction.amount, notJustifiedAmountSigned, variables)

            if (currentAccountBTItem.accountingLine.id) {
                variables.toDeleteAccountingLineIds.push(currentAccountBTItem.accountingLine.id);
            }

            // if (bankTransaction.accountableAccount) {
            //     variables.accountableAccount = { disconnect: true }
            // }

            if (currentAccountUser) {
                variables.accountingLines = [
                    {
                        // company: {connect: {id: this.selectedCompany.id}},
                        // wording: bankTransaction.wordingDisplay || bankTransaction.wordingOriginal,
                        // date: bankTransaction.dateDebit,
                        amountSigned: currentAccountBTItem.accountingLine.amountSigned,
                        // amount: Math.abs(currentAccountBTItem.accountingLine.amountSigned),
                        // accountableAccount: await getConnectAccountableAccount(this.$store, this.$apollo, accountableAccountName),
                        accountableAccountName,
                        userId: currentAccountUser.id,
                    },
                ];
            }

            const result = await this.$apollo.mutate({
                mutation: UPDATE_BANKTRANSACTION_ACCOUNTINGLINE,
                variables: variables,
            });
            await this.refresh();
        } else {
            debugger;
        }
    }

    showRemoveCurrentAccount(group) {
        if (!this.getCurrentAccountType(group)) {
            return false;
        }
        if (group.items.length !== 1) {
            return false;
        }
        for (const item of this.reconciliationItems) {
            if (isInsideClosedAccountingPeriod(this.$store, item.accountingLine.date)) {
                return false;
            }
            // if (item.accountingLine.bankTransaction && item.accountingLine.bankTransaction.accountingItemImport) {
            //     return false
            // }
            // if (item.accountingLine.reconciliation && item.accountingLine.reconciliation.accountingItemImport) {
            //     return false
            // }
        }
        return true;
    }

    get removeCurrentAccountTitle() {
        if (this.currentAccountType) {
            return (
                "Retirer du " +
                this.$t("reconciliation.action." + this.currentAccountType)
                    .toString()
                    .toLowerCase()
            );
        }
        // debugger
        return "Retirer du " + this.getCurrentAccountTitle().toString().toLowerCase();
    }

    async removeCurrentAccount(group) {
        if (this.getCurrentAccountType(group)) {
            const results = [];

            for (const item of group.items) {
                if (item.accountingLine.bankTransaction) {
                    const bankTransaction = item.accountingLine.bankTransaction;

                    const variables = {
                        id: bankTransaction.id,
                        // notJustifiedAmountSigned: 0,
                        // justifiedAmountSigned: 0,
                        toDeleteAccountingLineIds: [],
                    };
                    // let notJustifiedAmountSigned = bankTransaction.notJustifiedAmountSigned
                    // if (!item.accountingLine.id) {
                    //     notJustifiedAmountSigned -= item.accountingLine.amountSigned
                    // }
                    // computeJustifiedNotJustified(bankTransaction.amount, notJustifiedAmountSigned, variables)
                    if (item.accountingLine.id) {
                        variables.toDeleteAccountingLineIds.push(item.accountingLine.id);
                    }
                    // if (bankTransaction.accountableAccount) {
                    //     variables.accountableAccount = { disconnect: true }
                    // }
                    results.push(
                        this.$apollo.mutate({
                            mutation: UPDATE_BANKTRANSACTION_ACCOUNTINGLINE,
                            variables: variables,
                        }),
                    );
                }
            }
            if (results.length) {
                await Promise.all(results);
                await this.refresh();
            }
        }
    }

    getCurrentAccountTitle() {
        return this.legalForm !== "EI"
            ? this.$t("reconciliation.action.CURRENT_ACCOUNT")
            : this.$t("reconciliation.action.OPERATOR_ACCOUNT");
    }

    getDefaultCurrentAccount() {
        return this.legalForm !== "EI" ? "455000" : "108000";
    }

    //
    // cash payment
    //

    showCashPaymentDialog: boolean = false;
    cashPaymentActions = {
        action: new DialogAction(),
    };

    get cashPaymentDocItem(): any {
        // if (!this.selectedCompany.shop) return undefined
        if (this.reconciliation && this.reconciliation.id) {
            return undefined;
        }
        let docItem: any;
        for (const item of this.reconciliationItems) {
            if (item.bt) return undefined;
            if (item.accountingLine && !item.doc) return false;
            if (item.doc) {
                if (docItem) return undefined;
                docItem = item;
            }
        }
        return docItem;
    }

    async onCashPaymentDone(result) {
        this.showCashPaymentDialog = false;

        if (result.data && result.data.createReconciliation) {
            await this.createUserActivity(result.data.createReconciliation.id, "CREATE");
        }
        this.refresh();
    }

    //
    // cheque payment
    //

    showRemittanceDialog: boolean = false;
    chequePaymentActions = {
        action: new DialogAction(),
    };

    async onRemittanceDone(result) {
        this.showRemittanceDialog = false;

        if (result.data && result.data.createReconciliationWithRemittance) {
            await this.createUserActivity(
                result.data.createReconciliationWithRemittance.id,
                "CREATE",
            );
        }
        this.refresh();
    }

    //
    // cash withdrawal
    //

    showCashWithdrawalDialog: boolean = false;

    cashWithdrawalActions = {
        action: new DialogAction(),
    };

    get cashWithdrawalBTItem(): any {
        if (this.reconciliation && this.reconciliation.id) {
            return undefined;
        }
        let btItem: any;
        for (const item of this.reconciliationItems) {
            if (item.doc) return undefined;
            // if (item.accountingLine && !item.doc) return false;
            if (item.bt && item.is471AL) {
                if (item.bt.amount > 0) return undefined;
                if (btItem) return undefined;
                btItem = item;
            }
        }
        return btItem;
    }

    // debug: number = 0;

    @State2Way("updatePagination", "documentFilter.pagination")
    pagination!: any;

    formatDate(date: string) {
        return moment(date, "DD-MM-YYYY").format("DD MMMM YYYY");
    }

    formatDateMobile(date) {
        if (!date) return null;
        return moment(date, "DD-MM-YYYY").format("DD MMMM");
    }

    isFiltered(x: any, y: any): boolean {
        const optFields = ["showFilterBox", "totalItems"];
        if (x && y && typeof x === "object" && typeof y === "object") {
            return (
                Object.keys(x).length === Object.keys(y).length &&
                Object.keys(x).reduce((isEqual, key) => {
                    if (optFields.includes(key)) {
                        return isEqual;
                    }
                    return isEqual && this.isFiltered(x[key], y[key]);
                }, true)
            );
        }
        return x === y;
    }

    onBTDateRangeChanged(data: { begin: string; end: string }) {
        debugger;
        this.btFilter.date.begin = data.begin;
        this.btFilter.date.end = data.end;
    }

    onReconciliationDateRangeChanged(data: { begin: string; end: string }) {
        this.reconciliationFilter.date.begin = data.begin;
        this.reconciliationFilter.date.end = data.end;
    }

    clearBTFilters() {
        this.btFilter = JSON.parse(JSON.stringify(this.defaultBTFilter));
    }

    clearReconciliationFilters() {
        this.reconciliationFilter = JSON.parse(JSON.stringify(this.defaultReconciliationFilter));
    }

    getDisabledAccountableAccount(item) {
        if (!item.editable) {
            return true;
        }
        return item.disabledAccountableAccount;
    }

    // initializeSubAccountAccount(item) {
    //
    // obsolote
    //
    // item.subCreditTotal = 0.0
    // item.subDebitTotal = 0.0
    // item.credit_1 = 0.0
    // item.debit_1 = 0.0
    // item.accountableAccount1 = undefined
    // item.validated_1 = false
    // item.credit_2 = 0.0
    // item.debit_2 = 0.0
    // item.accountableAccount2 = undefined
    // item.validated_2 = false
    // item.netAmount_1 = 0.0
    // item.netAmount_2 = 0.0
    // }

    getDebit2AccountableType(item) {
        if (item.accoutningLine) return "";
        return "627100";
    }

    getValidateButtonTitle() {
        if (this.reconciliation && this.reconciliation.status === "VALIDATED") {
            return "Validé";
        }
        return "Valider";
    }

    getToReconciliateBTWithDocuments(group) {
        if (!group) {
            return undefined;
        }
        if (group.reconciliation) {
            return undefined;
        }
        if (group.items.length !== 1) {
            return undefined;
        }
        const item = group.items[0];
        return item.bt && item.is471AL ? item : undefined;
    }

    showSuggestedDocuments(group) {
        return group && group.reconciliation && group.reconciliation.toReplaceDocumentType;
    }

    //
    // reconciliations
    //

    @Apollo({
        query() {
            return RECONCILIATION_WITH_SEARCH_QUERY;
        },
        variables() {
            return {
                companyId: this.selectedCompany.id,
                search:
                    this.reconciliationFilter.search.length > 0
                        ? this.reconciliationFilter.search
                        : undefined,
                minAmount: this.reconciliationFilter.amount.minimum
                    ? parseFloat(this.reconciliationFilter.amount.minimum)
                    : undefined,
                maxAmount: this.reconciliationFilter.amount.maximum
                    ? parseFloat(this.reconciliationFilter.amount.maximum)
                    : undefined,
                beginDate: getDBFormattedStartDate(this.reconciliationFilter.date.begin),
                endDate: getDBFormattedEndDate(this.reconciliationFilter.date.end),
                // first: this.docFilter.pagination.rowsPerPage > 0 ? this.docFilter.pagination.rowsPerPage : 100,
                // skip: this.docFilter.pagination.rowsPerPage * (this.docFilter.pagination.page - 1),
                // orderBy: this.formatOrderByDoc()
            };
        },
        debounce: 500,
        skip() {
            return !this.reconciliationPanel;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.reconciliationLoading = loading;
            if (!loading) {
                this.reconciliations = [];
                this.reconciliationPagination.totalItems = 0;
                debugger;
                // if (data && data.reconciliationsFromBTsAndDocuments && data.reconciliationsFromBTsAndDocuments.length) {
                //     this.reconciliations = data.reconciliationsFromBTsAndDocuments;
                //     this.reconciliationPagination.totalItems = this.reconciliations.length;
                //     for (const reconciliation of this.reconciliations) {
                //         reconciliation.reconciliationItems = [];
                //         for (let i = 0; i < reconciliation.bankTransactions.length; i++) {
                //             const bt = reconciliation.bankTransactions[i];
                //             const item = this.getBTItems(bt, true, true);
                //             reconciliation.reconciliationItems.push(item);
                //         }
                //         for (let i = 0; i < reconciliation.accountingLines.length; i++) {
                //             const accountingLine = reconciliation.accountingLines[i];
                //             const item = this.getDocAccountingLineItem(accountingLine, true, true);
                //             reconciliation.reconciliationItems.push(item);
                //         }
                //     }
                // }
            }
        },
    })
    reconciliations = [];

    // async selectReconciliation(reconciliation) {
    //     // this.selectedReconciliationId = reconciliation.id;
    //     this.previousReconciliationId = ""
    //     if (this.reconciliation) {
    //         this.previousReconciliationId = this.reconciliation.id;
    //     }
    //     this.reconciliation = reconciliation
    //     this.computeReconciliationItems(false)
    //     await this.updateReconciliation(!this.validateIsDisabled);
    //     this.removedInitialItems = [];
    //     this.previousReconciliationId = "";
    //     await this.refresh();
    // }

    onSelectItemChanged(item) {
        this._onSelectItemChanged(item);
    }

    _onSelectItemChanged(item) {
        if (item.selected) {
            this.addRecItem(item);
            this.updateAccountableAccounts();
        } else {
            const index = this.reconciliationItems.findIndex((child) => {
                if (item.id === child.id) {
                    return true;
                }
                return false;
            });
            if (index !== -1) {
                this.reconciliationItems.splice(index, 1);
                this.updateAccountableAccounts();
            } else {
                debugger;
            }
        }
    }

    addRemoveReconciliationExpend(item) {
        if (item.doc /*&& item.doc.status.startsWith("ANALYSED")*/) {
            this.selectedDocument = item.doc;
            this.documentDialog = true;
        }
        // else {
        //     const index = this.reconciliationExpanded.indexOf(item);
        //     if (index === -1) {
        //         this.reconciliationExpanded.push(item);
        //     } else {
        //         this.reconciliationExpanded.splice(index, 1);
        //     }
        // }
    }

    async onDocumentValidated() {
        debugger;
        if (this.selectedDocument) {
            this.selectedDocument.status = "VALIDATED";
        }
        // if (this.showValidateReconciliation(this.currentItem)) {
        await this.validateReconciliation(this.currentItem);
        // }
        // this.currentItem = null
        this.documentDialog = false;
        this.refresh(false);
    }

    expense(doc) {
        if (!doc) {
            debugger;
            return false;
        }
        return doc.grossAmountSigned < 0;
    }

    get totalCredit(): number {
        let total: number = 0.0;

        for (let i = 0; i < this.reconciliationItems.length; i++) {
            const item = this.reconciliationItems[i];

            if (item.amountSigned < 0) {
                total -= item.amountSigned;
            }
        }
        return total;
    }

    get totalDebit(): number {
        let total: number = 0.0;
        for (let i = 0; i < this.reconciliationItems.length; i++) {
            const item = this.reconciliationItems[i];

            if (item.amountSigned > 0) {
                total += item.amountSigned;
            }
        }
        return total;
    }

    get difference() {
        let total: number = 0.0;
        for (let i = 0; i < this.reconciliationItems.length; i++) {
            const item = this.reconciliationItems[i];
            if (item.isBT512) {
                continue;
            }
            total += item.amountSigned;
        }
        return total;
    }

    checkIfSuspenseAccount(accountableAccount) {
        if (
            accountableAccount &&
            (accountableAccount.name === suspensePurchaseAccount ||
                accountableAccount.name === suspenseSalesAccount)
        ) {
            return true;
        }
        return false;
    }

    get saveIsDisabled() {
        if (this.currentAccountType) {
            return false;
        }
        // if (this.cashBoxWithBTReconciliation) return true
        if (this.reconciliationItems.length + this.removedInitialItems.length <= 1) {
            return true;
        }
        if (this.reconciliation && this.reconciliation.id) return false;

        return false;
    }

    isAccountableAccountRequired(item) {
        if (!item.doc) return false;
        if (item.doc.zTillReceipt) return false;
        if (item.doc.type === "PAY_SLIP") return false;
        if (item.doc.type === "BANK_CHARGE") return false;
        if (item.doc.type === "ZTILL_RECEIPT") return false;
        if (item.doc.type === "VAT") return false;
        if (item.doc.type === "CARRY_FORWARD") return false;
        if (item.doc.type === "MISCELLANEOUS_OPERATION") return false;
        return true;
    }

    showSubAccountableAccount(item) {
        if (this.reconciliationExpanded.indexOf(item) === -1) {
            return false;
        }
        return true;
    }

    get reconciliation_id() {
        return "";
        // if (this.reconciliation && this.reconciliation.id) return this.reconciliation.id
        // return this.reconciliationId || ""
    }

    set reconciliation_id(value: string) {
        // this.reconciliation.id = value;
    }

    //     reconciliation: Reconciliation;

    getPrevNextVariables() {
        const variables = getCommonBTQueryVariables(
            [this.accountId],
            this.selectedAccountingClosing,
            this.$store.state.bankTransactionFilter,
            this.selectedCompany.id,
            false,
        );
        variables.bankTransactionId = this.bankTransactionId;
        return variables;
    }

    get accountId() {
        if (this.bankTransaction && this.bankTransaction.account) {
            return this.bankTransaction.account.id;
        }
        return "";
    }

    async refresh(checkMode: boolean = true) {
        debugger;

        this.itemReconciliations = {};
        this.removedInitialItems = [];
        this.reconciliationExpanded = [];

        await this.commonRefresh();

        this.suggestedDocumentPanel =
            this.reconciliation && this.reconciliation.toReplaceAccountingLineSuggestionItems
                ? !!this.reconciliation.toReplaceAccountingLineSuggestionItems.length
                : false;

        await this.updateAccountableAccounts();
        this.initializeBTFilter();
        this.initializeDocFilter();
        this.loading = false;
        if (checkMode) {
            if (this.mode === "GeneralLedger") {
                this.$emit("update");
                return;
            }
        }
    }

    activity: any;

    updatePrevNext() {
        let initPrevNext = true;
        if (this.bankTransactionId) {
            if (this.prevNext && this.prevNext.currentId === this.bankTransactionId) {
                this.previousBankTransactionId = this.prevNext.prevId;
                this.nextBankTransactionId = this.prevNext.nextId;
                initPrevNext = false;
            }
        }
        if (initPrevNext) {
            this.prevNext = {
                currentId: "",
                prevId: "",
                nextId: "",
            };
        }
    }

    async beforeMount() {
        this.updatePrevNext();
        // this.removeEventListener()
        // this.addEventListener()
        this.toCreateBankTransactions = undefined;
        this.initializeUserActivity();

        this.refresh(false);

        this.addPrevNextSmartQuery();
    }

    // removeEventListener() {
    //     document.removeEventListener("keydown", this.onKeyDown)
    // }

    // addEventListener() {
    //     document.addEventListener("keydown", this.onKeyDown)
    // }

    // onKeyDown(event) {
    //     const keyCode = event.keyCode || event.which;
    //     if (keyCode === 37) {
    //         this.previous()
    //     } else if (keyCode === 39) {
    //         this.next()
    //     }
    // }

    // beforeDestroy() {
    //     this.removeEventListener()
    // }

    // async updateReconciliationStatus(status) {
    //     const result = await this.$apollo.mutate({
    //         mutation: UPDATE_RECONCILIATION_STATUS,
    //         variables: {
    //             reconciliationId: this.reconciliation_id,
    //             status: status
    //         }
    //     });
    //     this.$router.push({ name: "bank" });
    // }
    // addBTUpdate(item:any)
    // {
    //         if (item && item.accountableAccount)
    //         {
    //                 return `updateBankTransaction_${item.id} : updateBankTransaction(
    //                         where: {id:"${item.id}"},
    //                         data:{
    //                                 accountableAccount:{connect:{id:"${item.accountableAccount.id}"}}
    //                         }
    //                 ){id}`
    //         }
    //         return "";
    // }
    // addDocumentUpdate(item:any)
    // {
    //         if (item && item.accountableAccount)
    //         {
    //                 return `updateDocument_${item.id} : updateDocument(
    //                         where: {id:"${item.id}"},
    //                         data:{
    //                         accountableAccount:{connect:{id:"${item.accountableAccount.id}"}}
    //                         }
    //                 ){id}`;
    //         }
    //         return "";
    // }

    skipSmartQuery(skip) {
        // if (this.$apollo.queries && this.$apollo.queries.reconciliationQuery) {
        //     this.$apollo.queries.reconciliationQuery.skip = skip;
        // } else {
        //     debugger;
        // }
    }

    saveLoading: boolean = false;

    // async save(validate) {
    //     this.saveLoading = true;
    //     await this.updateReconciliation(validate);
    //     await this.refresh();
    //     this.saveLoading = false;
    // }

    initializeUserActivity() {
        this.activity = new UserActivity("VALIDATE", "RECONCILIATION", moment());
    }

    async createUserActivity(reconciliationId, action) {
        await this.activity.create(
            this.$apollo,
            this.currentUser.id,
            this.selectedCompany.id,
            reconciliationId,
            action,
        );
        this.initializeUserActivity();
    }
    //
    //
    //
    removeImputationTitle(group) {
        const item = this.getGroupNotReconciliatedAndWithImputation(group);
        if (item.accountingLine.accountableAccount) {
            if (item.accountingLine.accountableAccount.name.startsWith("455000")) {
                return "Retirer du compte courant";
            }
            if (item.accountingLine.accountableAccount.name.startsWith("180000")) {
                return "Retirer du compte de l'exploitant";
            }
            if (item.accountingLine.accountableAccount.name.startsWith("467000")) {
                return "Retirer du compte débiteur | créditeur";
            }
            if (item.accountingLine.accountableAccount.name.startsWith("411000")) {
                return "Retirer du compte client";
            }
            if (item.accountingLine.accountableAccount.name.startsWith("401000")) {
                return "Retirer du compte fournisseur";
            }
            if (
                socialAccountableAccounts.indexOf(item.accountingLine.accountableAccount.name) !==
                -1
            ) {
                return "Retirer du compte social";
            }
            if (
                stateAccountableAccounts.indexOf(item.accountingLine.accountableAccount.name) !== -1
            ) {
                return "Retirer du compte état";
            }
        }
        return "Retirer";
    }

    enableRemoveImputation(group) {
        const item = this.getGroupNotReconciliatedAndWithImputation(group);
        if (!item) {
            debugger;
            return false;
        }
        if (!item.bt || !item.accountingLine.id || item.isBT512) {
            return false;
        }
        if (isInsideClosedAccountingPeriod(this.$store, item.accountingLine.date)) {
            return false;
        }
        // if (item.bt.accountingItemImport) {
        //     return false
        // }
        return true;
    }

    async deallocateBankTransactions() {
        await this.$apollo.mutate({
            mutation: REMOVE_LINKED_ACCOUNTING_LINES,
            variables: {
                ids: [this.bankTransaction.id],
            },
        });
        this.bankTransaction.accountingLines = this.bankTransaction.accountingLines.filter((al) =>
            al.accountableAccount?.name?.startsWith("512"),
        );

        await this.refresh();
    }

    async removeImputation(group) {
        if (!this.enableRemoveImputation(group)) {
            debugger;
            return;
        }
        const item = this.getGroupNotReconciliatedAndWithImputation(group);
        if (!item) {
            debugger;
            return;
        }
        if (!item.bt || !item.accountingLine.id || item.isBT512) {
            return;
        }

        const bankTransaction = item.bt;
        // const notJustifiedAmountSigned  = bankTransaction.notJustifiedAmountSigned - item.accountingLine.amountSigned

        const variables: any = {
            id: bankTransaction.id,
            toDeleteAccountingLineIds: [item.accountingLine.id],
        };
        // computeJustifiedNotJustified(bankTransaction.amount, notJustifiedAmountSigned, variables)

        // if (bankTransaction.accountableAccount) {
        //     variables.accountableAccount = { disconnect: true }
        // }

        await this.$apollo.mutate({
            mutation: UPDATE_BANKTRANSACTION_ACCOUNTINGLINE,
            variables: variables,
        });
        await this.refresh();
    }

    showDeleteReconciliation(group) {
        if (this.showValidateReconciliation(group)) {
            return false;
        }
        if (!group.reconciliation || !group.reconciliation.id) {
            return false;
        }
        const reconciliation = this.itemReconciliations[group.reconciliation.id];

        if (reconciliation) {
            for (const accountingLine of reconciliation.accountingLines) {
                if (accountingLine.document && accountingLine.document.type === "ZTILL_RECEIPT") {
                    return false;
                }
            }
            return true;
        }

        return false;
    }

    async deleteReconciliation(group) {
        this.actionLoading = true;

        const reconciliation = this.itemReconciliations[group.reconciliation.id];
        if (reconciliation && reconciliation.accountingLines.length) {
            await this.$apollo.mutate({
                mutation: DELETE_RECONCILIATION,
                variables: {
                    reconciliationId: reconciliation.id,
                },
            });
            await this.createUserActivity(reconciliation.id, "DELETE");
            //
            // refresh page
            //
            if (this.mode === "GeneralLedger") {
                await this.refresh();
                return;
            }
            if (reconciliation.id === this.reconciliationId) {
                const toDeleteDocTypes = [
                    "WITHOUT_INVOICE",
                    "WITH_DELTA",
                    "BANK_CHARGE",
                    "SALES_INVOICE_AUTO",
                ];
                for (const recItem of group.items) {
                    if (recItem.bt) {
                        this.$router.push({
                            name: "reconciliation/bankTransaction",
                            params: {
                                companyId: this.selectedCompany.id,
                                bankTransactionId: recItem.bt.id,
                            },
                        });
                        return;
                    }
                    if (
                        recItem.doc &&
                        toDeleteDocTypes.indexOf(recItem.doc.type) === -1 &&
                        recItem.accountingLine &&
                        recItem.accountingLine.id
                    ) {
                        this.$router.push({
                            name: "reconciliation/accountingLine",
                            params: {
                                companyId: this.selectedCompany.id,
                                accountingLineId: recItem.accountingLine.id,
                            },
                        });
                        return;
                    }
                }
            }

            await this.refresh();
        }
        this.actionLoading = false;
    }

    async addAccountingLine(accountingLineItem) {
        const btItem = this.getToReconciliateBTWithDocuments(this.selectedGroup);

        if (btItem) {
            if (this.selectedCompany.profile?.accountingType === "INCOMING_OUTGOING_PAYMENT") {
                if (accountingLineItem.accountingLine?.document) {
                    await this.$apollo.mutate({
                        mutation: LINK_BANKTRANSACTION_AND_DOCUMENT,
                        variables: {
                            documentId: accountingLineItem.accountingLine.document.id,
                            bankTransactionId: btItem.bt.id,
                            btAccountingLineId: btItem.accountingLine.id,
                            documentAccountingLineId: accountingLineItem.accountingLine.id,
                            isIncomingOutgoingPayment: this.isIncomingOutgoingPayment,
                            bankTransactionDate: btItem.bt.dateDebit,
                        },
                    });
                } else {
                    debugger;
                }

                debugger;
            } else {
                const docType = accountingLineItem.accountingLine.document
                    ? accountingLineItem.accountingLine.document.type
                    : "";
                await this.reconciliateAlWithBT(
                    undefined,
                    btItem.bt,
                    btItem.accountingLine,
                    accountingLineItem.accountingLine,
                    docType,
                );
            }
        }
        this.closeAllPanels();
        await this.refresh();
    }

    async validateReconciliation(group) {
        if (this.containsDocumentToValidate(group)) {
            debugger;
            return;
        }
        this.actionLoading = true;
        // debugger
        if (group && group.reconciliation && group.reconciliation.id && group.items.length >= 2) {
            await this.$apollo.mutate({
                mutation: VALIDATE_RECONCILIATION,
                variables: {
                    id: group.reconciliation.id,
                },
            });
            if (!this.isIncomingOutgoingPayment) {
                // compta d'engagement
                this.createUserActivity(group.reconciliation.id, "VALIDATE");
            }
            this.actionLoading = false;
            await this.refresh();
        }
    }

    async reconciliateAlWithBT(
        type,
        bankTransaction,
        btAccountingLine,
        accountingLine,
        reason,
        toReplaceDocumentType: string = undefined,
        updateAccountingLine = undefined,
    ) {
        const result = await reconciliateAlWithBT(
            this.$apollo,
            this.currentUser.id,
            this.selectedCompany.id,
            type,
            bankTransaction,
            btAccountingLine,
            accountingLine,
            reason,
            toReplaceDocumentType,
            updateAccountingLine,
        );

        if (result.data && result.data.createReconciliation) {
            await this.createUserActivity(result.data.createReconciliation.id, "CREATE");
        }
    }

    async createClientReconciliation(
        bankTransaction,
        btAccountingLine,
        documentId,
        fromClient: boolean = true,
    ) {
        this.actionLoading = false;
        const toConnectAccountingLines = [];
        const bankTransactions = [];
        const status = fromClient ? "PENDING_VALIDATION_FROM_CLIENT" : "PENDING_VALIDATION";

        const existingBTAccountingLine = btAccountingLine;
        if (!existingBTAccountingLine || !existingBTAccountingLine.id) {
            bankTransactions.push({
                id: bankTransaction.id,
            });
        } else {
            toConnectAccountingLines.push({ id: existingBTAccountingLine.id });
        }

        const result = await this.$apollo.mutate({
            mutation: CREATE_RECONCILIATION_FROM_CLIENT,
            variables: {
                companyId: this.selectedCompany.id,
                documentId: documentId,
                bankTransactions: bankTransactions,
                accountingLines: toConnectAccountingLines,
                status,
            },
        });
        if (result.data && result.data.createReconciliation) {
            await this.createUserActivity(result.data.createReconciliation.id, "CREATE");
            this.removedInitialItems = [];
            // await this.refresh();
        }
        this.actionLoading = true;
    }

    async linkWithCashWithdrawal() {
        if (this.cashWithdrawalBTItem && this.cashWithdrawalBTItem.bt) {
            await linkBankTransactionWithCashBox(this.$apollo, [this.cashWithdrawalBTItem.bt]);

            await this.refresh();
        }
    }

    //
    // cashbox
    //

    showRemoveCashbox(group) {
        const reconciliation =
            this.getCashBoxWithBTReconciliation(group) ||
            this.getCashBoxWithDocumentReconciliation(group);
        if (!reconciliation /*|| reconciliation.accountingItemImport*/) {
            return undefined;
        }
        return reconciliation.id;
    }

    async removeCashbox(group) {
        this.actionLoading = true;
        const reconciliationId = this.showRemoveCashbox(group);
        if (reconciliationId) {
            await this.$apollo.mutate({
                mutation: REMOVE_TO_CASHBOX,
                variables: {
                    reconciliationId: reconciliationId,
                },
            });
            await this.refresh();
        }
        this.actionLoading = false;
    }

    //
    // cheque payment (waiting)
    //
    showRemoveRemittance(group) {
        const reconciliation = this.getRemittanceWithDocumentReconciliation(group);
        if (!reconciliation /*|| reconciliation.accountingItemImport*/) {
            return undefined;
        }
        return reconciliation.id;
    }

    initializeMinMax(filter) {
        let totalAmount = 0.0;
        for (const item of this.reconciliationItems) {
            if (item.isBT512) {
                continue;
            }
            if (item.accountingLine) {
                totalAmount += item.accountingLine.amountSigned;
            } else if (item.bt) {
                totalAmount += item.bt.amount;
            } else {
                debugger;
            }
        }

        if (totalAmount > 0) {
            filter.amount.maximum = "0";
        } else {
            filter.amount.minimum = "0";
        }
    }

    initializeBTFilter() {
        this.btFilter = JSON.parse(JSON.stringify(this.defaultBTFilter));
        this.initializeMinMax(this.btFilter);
    }

    initializeDocFilter() {
        this.docFilter = JSON.parse(JSON.stringify(this.defaultDocFilter));
        this.initializeMinMax(this.docFilter);
    }

    getMQInt(search) {
        const qInt = getStringAsFloat(this.btFilter.search);
        if (qInt !== undefined) {
            return -qInt;
        }
        return qInt;
    }

    @Apollo({
        query() {
            return RECONCILIATION_BT_QUERY;
        },
        variables() {
            return {
                companyId: this.selectedCompany.id,
                q: this.btFilter.search.length > 0 ? this.btFilter.search : undefined,
                qInt: getStringAsFloat(this.btFilter.search),
                mqInt: this.getMQInt(),
                minAmount: this.btFilter.amount.minimum
                    ? parseFloat(this.btFilter.amount.minimum)
                    : undefined,
                maxAmount: this.btFilter.amount.maximum
                    ? parseFloat(this.btFilter.amount.maximum)
                    : undefined,
                beginDate: getDBFormattedStartDate(this.btFilter.date.begin),
                endDate: getDBFormattedEndDate(this.btFilter.date.end),
                first:
                    this.btFilter.pagination.rowsPerPage > 0
                        ? this.btFilter.pagination.rowsPerPage
                        : 100,
                skip: this.btFilter.pagination.rowsPerPage * (this.btFilter.pagination.page - 1),
                orderBy: formatOrderBy(this.btFilter.pagination, "dateDebit"),
            };
        },
        debounce: 500,
        skip() {
            return !this.bankTransactionPanel;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingBT = loading;
            if (!loading) {
                this.availableBankTransactions = [];
                if (data && data.bankTransactions) {
                    for (let i = 0; i < data.bankTransactions.length; i++) {
                        const bt = data.bankTransactions[i];
                        // const selected = this.reconciliationItems.find((item) => {
                        //     if (item.id === bt.id) {
                        //         return true;
                        //     }
                        //     return false;
                        // });
                        this.getAvailableBTItems(bt, this.availableBankTransactions);
                        // this.availableBankTransactions.push(item);
                    }

                    if (data.bankTransactionsConnection) {
                        this.btFilter.pagination.totalItems = data.bankTransactionsConnection.count;
                    }
                }
            }
        },
    })
    availableBankTransactions = [];

    // formatOrderByBT() {
    //     const fieldName = this.btFilter.pagination.sortBy || "dateDebit";
    //     let direction = "";
    //     if (fieldName !== "updatedAt") {
    //         direction = this.btFilter.pagination.descending ? "_DESC" : "_ASC";
    //     } else {
    //         direction = this.btFilter.pagination.descending ? "_ASC" : "_DESC";
    //     }
    //     return fieldName + direction;
    // }

    // applyThirdPartyAccountableAccount() {
    // if (this.reconciliationItems.length === 2) {
    //     let docItem;
    //     let btItem;
    //     for (const recItem of this.reconciliationItems) {
    //         if (recItem.doc) {
    //             docItem = recItem;
    //         } else if (recItem.bt) {
    //             btItem = recItem;
    //         }
    //     }
    //     if (docItem && btItem && docItem.doc.thirdPartyAccountableAccount) {
    //         btItem.bt.accountableAccount = docItem.doc.thirdPartyAccountableAccount;
    //         btItem.accountableAccount = docItem.doc.thirdPartyAccountableAccount;
    //     }
    // }
    // }

    async updateAccountableAccounts() {
        // this.applyThirdPartyAccountableAccount();
    }

    closeAccountableAccount() {}

    selectAccountableAccount(data) {
        if (data.itemId) {
            const index = this.reconciliationItems.findIndex((item) => item.id === data.itemId);
            if (index >= 0 && index < this.reconciliationItems.length) {
                const item = this.reconciliationItems[index];
                // item.validated = data.validated;
                item.accountableAccount = data.accountableAccount;
            } else {
                debugger;
            }
        }
    }

    selectThirdPartyAccountableAccount(data) {
        if (data.item) {
            const item = data.item;
            if (item.accountingLine) {
                item.accountingLine.accountableAccount = data.thirdPartyAccountableAccount;
                if (item.accountingLine.reconciliation) {
                    for (const recItem of this.reconciliationItems) {
                        if (
                            recItem !== item &&
                            recItem.accountingLine &&
                            recItem.accountingLine.reconciliation &&
                            recItem.accountingLine.reconciliation.id ===
                                item.accountingLine.reconciliation.id
                        ) {
                            recItem.accountingLine.accountableAccount =
                                data.thirdPartyAccountableAccount;
                        }
                    }
                }
            } else if (item.doc) {
                item.thirdPartyAccountableAccount = data.thirdPartyAccountableAccount;
            } else if (item.bt) {
                item.accountableAccount = data.thirdPartyAccountableAccount;
            }
        } else {
            debugger;
        }
    }
    //
    // sub value
    //

    subValueRules = {
        min: (value) => value >= 0 || "only positive value",
        // required: value => !!value || 'Required.',
        // counter: value => value.length <= 20 || 'Max 20 characters',
        // email: value => {
        // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        // return pattern.test(value) || 'Invalid e-mail.'
        // }
    };

    //
    // reconciliate 1N
    //
    // reconciliation1NPanel = false;
    // // reconciliation1NLoading = false;

    // get reconciliation1NLoading() {
    //     if (this.$apollo.queries.reconciliation1Ns) {
    //         return this.$apollo.queries.reconciliation1Ns.loading
    //     }
    //     return false;
    // }

    // getBTForReconciliation1N() {
    //     let btItem;
    //     for (const item of this.reconciliationItems) {
    //         if (item.doc) return null;
    //         // if (item.bt && item.bt.amount > 0) return false;
    //         if (item.bt) {
    //             if (btItem) return null;
    //             btItem = item;
    //         }
    //     }
    //     return btItem;
    // }

    // activateReconciliation1NPanel() {
    //     return !!this.getBTForReconciliation1N();
    //     // return Math.abs(this.totalCredit - this.totalDebit) > 1.0
    // }

    // get reconciliation1NDocuments() {
    //     const documents = []
    //     for (const item of this.reconciliationItems) {
    //         if (item.doc) {
    //             documents.push(item.doc.id);
    //         }
    //     }
    //     return documents;
    // }

    // get reconciliation1NBTs() {
    //     const bankTransactions = [];
    //     for (const item of this.reconciliationItems) {
    //         if (item.bt) {
    //             bankTransactions.push(item.bt.id);
    //         }
    //     }
    //     return bankTransactions;
    // }

    // @Apollo({
    //     query() {
    //         return RECONCILIATE_NN;
    //     },
    //     variables() {
    //         return {
    //             companyId: this.selectedCompany.id,
    //             targetAmount: this.totalDebit - this.totalCredit,
    //             documents: this.reconciliation1NDocuments,
    //             bankTransactions: this.reconciliation1NBTs
    //         };
    //     },
    //     debounce: 500,
    //     skip() {
    //         return !this.reconciliation1NPanel || !this.getBTForReconciliation1N();
    //     },
    //     async specificResult({ data, loading, networkStatus }: any) {
    //         this.reconciliationLoading = loading;
    //         if (!loading) {
    //             if (data && data.reconciliateNN && data.reconciliateNN.result) {
    //                 let documents = [];

    //                 const foundDocuments = [];
    //                 for (const solution of data.reconciliateNN.result.solutions) {
    //                     for (const amount of solution.amounts) {
    //                         for (const docId of amount.documents) {
    //                             if (!foundDocuments.find(fd => fd === docId)) {
    //                                 foundDocuments.push(docId);
    //                             }
    //                         }
    //                     }
    //                 }

    //                 if (foundDocuments.length) {
    //                     const docResult = await this.$apollo.query({
    //                         query: RECONCILIATION_1N_DOCUMENT_QUERY,
    //                         variables: {
    //                             documents: foundDocuments
    //                         }
    //                     });
    //                     if (docResult && docResult.data && docResult.data.documents) {
    //                         documents = docResult.data.documents;
    //                     } else {
    //                         debugger;
    //                     }
    //                 }

    //                 this.reconciliation1Ns.splice(0, this.reconciliation1Ns.length);
    //                 let recIndex = 0;
    //                 for (const solution of data.reconciliateNN.result.solutions) {
    //                     const reconciliation = {
    //                         id: recIndex,
    //                         status: "EDITION",
    //                         type: "DEFAULT",
    //                         reconciliationItems: [],
    //                         amountSigned: 0.0,
    //                         debit: 0.0,
    //                         credit: 0.0
    //                     }
    //                     let total = 0;
    //                     const usedDocs = {};
    //                     for (const amount of solution.amounts) {
    //                         if (amount.documents && amount.documents) {
    //                             for (const index in amount.documents) {
    //                                 if (index !== undefined) {
    //                                     const doc = documents.find(d => d.id === amount.documents[index]);
    //                                     amount.documents[index] = doc;
    //                                 }
    //                             }
    //                             let amountDoc;
    //                             let adi = 0;
    //                             for (const ad of amount.documents) {
    //                                 if (!usedDocs[ad.id]) {
    //                                     amountDoc = ad;
    //                                     usedDocs[ad.id] = true
    //                                     break;
    //                                 } else {
    //                                     adi++;
    //                                 }
    //                             }
    //                             if (amountDoc) {
    //                                 const item = this.getDocItems(amountDoc, false, false);
    //                                 usedDocs[amountDoc.id] = true;
    //                                 item.id += "_" + recIndex;
    //                                 item.amount = amount;
    //                                 item.amountDocIndex = adi;
    //                                 reconciliation.reconciliationItems.push(item);
    //                                 total += amountDoc.grossAmountSigned;
    //                             } else {
    //                                 debugger;
    //                             }
    //                         }
    //                     }
    //                     reconciliation.amountSigned = total;
    //                     if (total < 0) {
    //                         reconciliation.debit = -total;
    //                     } else {
    //                         reconciliation.credit = total;
    //                     }
    //                     this.reconciliation1Ns.push(reconciliation);
    //                     recIndex++;
    //                 }
    //                 this.reconciliation1NPagination.totalItems = this.reconciliation1Ns.length;
    //             } else {
    //                 this.reconciliation1Ns.splice(0, this.reconciliation1Ns.length);
    //                 this.reconciliation1NPagination.totalItems = 0;
    //             }
    //         }
    //     }
    // })
    // reconciliation1Ns = [];

    // selectReconciliation1N(reconciliation) {
    //     for (const item of reconciliation.reconciliationItems) {
    //         const toAdditem:any = this.getDocItems(item.doc, true, false);
    //         this.addRecItem(toAdditem)
    //     }
    //     this.updateAccountableAccounts();
    //     this.reconciliation1NPanel = false;
    // }

    // reconciliation1NItemCarouselAvailable(item, docItem) {
    //     if (docItem.carousel === undefined) {
    //         const docCount = docItem.amount.documents.length;
    //         if (docCount <= 1) {
    //             docItem.carousel = false;
    //         }
    //         const amount = docItem.amount.amount;
    //         let amountCount = 0;
    //         for (const recItem of item.reconciliationItems) {
    //             if (recItem.amount.amount === amount) {
    //                 amountCount++;
    //             }
    //         }
    //         if (docCount === amountCount) {
    //             docItem.carousel = false;
    //         } else {
    //             docItem.carousel = true;
    //         }
    //         for (const recItem of item.reconciliationItems) {
    //             if (recItem.amount.amount === amount) {
    //                 recItem.carousel = docItem.carousel;
    //             }
    //         }
    //     }
    //     return docItem.carousel;
    // }

    // getNextReconciliation1NItemDocument(reconciliation, docItem) {
    //     for (let i = docItem.amountDocIndex + 1; i < docItem.amount.documents.length; i++) {
    //         const doc = docItem.amount.documents[i];
    //         let ri = 0;
    //         for (;ri < reconciliation.reconciliationItems.length; ri++) {
    //             if (reconciliation.reconciliationItems[ri].doc.id === doc.id) {
    //                 break;
    //             }
    //         }
    //         if (ri === reconciliation.reconciliationItems.length) {
    //             return i;
    //         }
    //     }
    //     return -1;
    // }

    // getPreviousReconciliation1NItemDocument(reconciliation, docItem) {
    //     // return docItem.amountDocIndex - 1 >= 0
    //     for (let i = docItem.amountDocIndex - 1; i >= 0; i--) {
    //         const doc = docItem.amount.documents[i];
    //         let ri = 0;
    //         for (; ri < reconciliation.reconciliationItems.length; ri++) {
    //             if (reconciliation.reconciliationItems[ri].doc.id === doc.id) {
    //                 break;
    //             }
    //         }
    //         if (ri === reconciliation.reconciliationItems.length) {
    //             return i;
    //         }
    //     }
    //     return -1;
    // }

    // nextReconciliation1NItemDocument(reconciliation, docItem) {
    //     const prevIndex = docItem.amountDocIndex;
    //     // const nextIndex = docItem.amountDocIndex + 1 < docItem.amount.documents.length ? docItem.amountDocIndex + 1 : prevIndex;
    //     const nextIndex = this.getNextReconciliation1NItemDocument(reconciliation, docItem);
    //     if (nextIndex !== -1 && prevIndex !== nextIndex) {
    //         const newDocItem:any = this.getDocItems(docItem.amount.documents[nextIndex], false, false);
    //         newDocItem.amount = docItem.amount;
    //         newDocItem.amountDocIndex = nextIndex;
    //         const itemIndex = reconciliation.reconciliationItems.findIndex(ri => ri === docItem);
    //         if (itemIndex !== -1) {
    //             newDocItem.id += "_" + itemIndex;
    //             reconciliation.reconciliationItems.splice(itemIndex, 1, newDocItem);
    //         }
    //     }
    // }

    // previousReconciliation1NItemDocument(reconciliation, docItem) {
    //     const prevIndex = docItem.amountDocIndex;
    //     // const nextIndex = docItem.amountDocIndex - 1 >= 0 ? docItem.amountDocIndex - 1 : prevIndex;
    //     const nextIndex = this.getPreviousReconciliation1NItemDocument(reconciliation, docItem);
    //     if (nextIndex !== -1 && prevIndex !== nextIndex) {
    //         const newDocItem:any = this.getDocItems(docItem.amount.documents[nextIndex], false, false);
    //         newDocItem.amount = docItem.amount;
    //         newDocItem.amountDocIndex = nextIndex;
    //         const itemIndex = reconciliation.reconciliationItems.findIndex(ri => ri === docItem);
    //         if (itemIndex !== -1) {
    //             newDocItem.id += "_" + itemIndex;
    //             reconciliation.reconciliationItems.splice(itemIndex, 1, newDocItem);
    //         }
    //     }
    // }

    //
    //
    //

    showMenuForDoc(group) {
        if (this.cashPaymentDocItem) {
            return true;
        }
    }

    showMenuForBT(group) {
        if (this.getToReconciliateBTWithDocuments(group)) {
            return true;
        }
        if (this.showSuggestedDocuments(group)) {
            return true;
        }
        if (this.getWithDeltaBT(group)) {
            return true;
        }
        if (this.getLoanBT(group)) {
            return true;
        }
        if (this.getCommissionBTItem(group)) {
            return true;
        }
        if (this.showAutoSalesReconciliation(group)) {
            return true;
        }
        if (this.getWithoutInvoiceBT(group)) {
            return true;
        }
        if (this.getThirdPartyCompanyBTItem(group)) {
            return true;
        }
        if (this.getZTillBT(group)) {
            return true;
        }
        if (this.getCurrentAccountBTItem(group)) {
            return true;
        }

        return false;
    }

    needsAction(group) {
        if (this.showMenuForBT(group)) return true;
        if (this.showMenuForDoc(group)) return true;
        return false;
    }

    async onNewDocument(document) {
        debugger;
        if (document && document.id) {
            for (const group of this.groupedAccountingLines) {
                const btItem = this.getToReconciliateBTWithDocuments(group);
                if (btItem) {
                    await this.createClientReconciliation(
                        btItem.bt,
                        btItem.accountingLine,
                        document.id,
                        false,
                    );
                    this.$emit("new-document");
                    return;
                }
            }
        }
        debugger;
    }

    getCellStyle(index, transparent) {
        let style = "";

        if (index === 0) {
            style += "border-top: solid 12px #F1F1F1 !important;";
        }
        if (transparent) {
            style +=
                "background-color: #F1F1F1 !important; border-bottom: solid 1px #F1F1F1 !important;";
        }
        return style;
    }

    onDocDateRangeChanged(data) {
        this.docFilter.date.begin = data.begin;
        this.docFilter.date.end = data.end;
    }

    addRemoveDocumentExpand(item) {
        const index = this.documentExpanded.indexOf(item);
        if (index === -1) {
            this.documentExpanded.push(item);
        } else {
            this.documentExpanded.splice(index, 1);
        }
    }

    @Apollo({
        query() {
            return RECONCILIATION_ACCOUNTING_LINE_QUERY;
        },
        variables() {
            return this.reconciliationAccountingLineWhere;
        },
        debounce: 500,
        skip() {
            return this.miscellaneousMode;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                this.accountingLines = [];
                this.documentExpanded = [];
                if (data?.accountingLines) {
                    for (const al of data.accountingLines) {
                        let selected = false;
                        if (this.reconciliationItems) {
                            selected = !!this.reconciliationItems.find(
                                (item) => item.accountingLine && item.accountingLine.id === al.id,
                            );
                        }
                        const item = this.getDocAccountingLineItem(al, selected, false);
                        if (!item) {
                            continue;
                        }
                        this.accountingLines.push(item);
                    }
                    if (data.accountingLinesConnection) {
                        this.docFilter.pagination.totalItems =
                            data.accountingLinesConnection.aggregate.count;
                    } else {
                        debugger;
                        this.docFilter.pagination.totalItems = 0;
                    }
                }
            }
        },
    })
    accountingLines = [];

    clearDocFilters() {
        this.docFilter = JSON.parse(JSON.stringify(this.defaultDocFilter));
    }

    enableShowGeneralLedger(group) {
        if (this.showValidateReconciliation(group)) {
            return false;
        }
        if (
            !group.items.length ||
            group.items[0].accountingLine.accountableAccount?.name.startsWith("471000")
        ) {
            return false;
        }
        return true;
    }
}
